import Modal from "@/common/components/Modal";
import useModalMessagesSimple from "@/common/hooks/useModalMessagesSimple";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteDashboardComponents } from "../../hooks/dashboards/useDeleteDashboardComponent";

interface DeleteDashboardComponentProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  dashboardId: string;
  dashboardComponentId: string | undefined;
}

const DeleteDashboardComponent = ({
  isOpen,
  setIsOpen,
  dashboardId,
  dashboardComponentId,
}: DeleteDashboardComponentProps) => {
  const queryClient = useQueryClient();

  const { setMessages } = useModalMessagesSimple({
    isError: true,
  });

  const {
    mutate: deleteDashboardComponent,
    isPending: deleteDashboardComponentIsPending,
  } = useDeleteDashboardComponents({
    dashboardId,
    dashboardComponentId,
    options: {
      onMutate: () => {
        queryClient.cancelQueries({
          queryKey: ['updateDashboardComponentsPosition', dashboardId],
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['dashboard', dashboardId],
        });

        setIsOpen(false);
      },
      onError: (error) => setMessages(error, {
        errorResponse: true,
      }),
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="rounded-lg overflow-hidden"
      title="Você tem certeza?"
      showClose={false}
      useCancellableFooter
      onConfirm={() => deleteDashboardComponent()}
      confirmButtonIsLoading={deleteDashboardComponentIsPending}
    />
  );
}

export default DeleteDashboardComponent;
